import type { IntlShape } from "react-intl";

export type TemperatureOption = {
  label: string;
  value: string;
  supportingText?: string;
};

export function getTemperatureOptionsV2(intl: IntlShape): TemperatureOption[] {
  const options: TemperatureOption[] = [
    {
      value: "1",
      label: intl.formatMessage({
        id: "request-form.packing-list.temperature.deepFrozen",
        defaultMessage: "Deep frozen",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.temperature.deepFrozenRange",
        defaultMessage: "Below -20°C (4°F)",
      }),
    },
    {
      value: "2",
      label: intl.formatMessage({
        id: "request-form.packing-list.temperature.storeFrozen",
        defaultMessage: "Frozen",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.temperature.storeFrozenRange",
        defaultMessage: "-20°C (4°F)",
      }),
    },
    {
      value: "3",
      label: intl.formatMessage({
        id: "request-form.packing-list.temperature.storeAt2to8",
        defaultMessage: "Cold",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.temperature.storeAt2to8Range",
        defaultMessage: "2°- 8°C (36°- 46°F)",
      }),
    },
    {
      value: "4",
      label: intl.formatMessage({
        id: "request-form.packing-list.temperature.cool",
        defaultMessage: "Cool",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.temperature.coolRange",
        defaultMessage: "8°-15°C (45°-59°F)",
      }),
    },
    {
      value: "5",
      label: intl.formatMessage({
        id: "request-form.packing-list.temperature.roomTemperature",
        defaultMessage: "Room temperature",
      }),
      supportingText: intl.formatMessage({
        id: "request-form.packing-list.temperature.roomTemperatureRange",
        defaultMessage: "15°C-25°C (59°F-77°C)",
      }),
    },
    {
      value: "6",
      label: intl.formatMessage({
        id: "request-form.packing-list.temperature.custom",
        defaultMessage: "Custom",
      }),
    },
  ];

  return options.map((opt) => ({
    label: opt.label,
    value: String(opt.value),
    supportingText: opt.supportingText,
  }));
}
